import { IAudioChunk } from "../interfaces/IAppState"
import { AudioChuckActionType } from "../constants/actionTypes"
import { filter, findIndex, findLast, isNil, set } from "lodash"

function init() {
	return [] as IAudioChunk[]
}

export const audioChucksReducer = function (initialState = init(), action: any) {
	switch (action.type) {
		case AudioChuckActionType.PUSH_AUDIO_CHUCK: {
			const lastAudioChuck = findLast(initialState, (chunk: IAudioChunk) => chunk.appointmentId === action.payload.appointmentId)
			const nextChuckId = !isNil(lastAudioChuck) ? Number(lastAudioChuck.id || 0) + 1 : 0
			return [...initialState, { ...action.payload, id: nextChuckId }]
		}
		case AudioChuckActionType.UPDATE_AUDIO_CHUCK: {
			const updatedAudioChucks = [...initialState]
			const updateIdx = findIndex(updatedAudioChucks, (chuck) => chuck.id === action.payload.id)
			if (updateIdx > -1) {
				if (action?.payload?.state === "COMPLETED" || action?.payload?.retriesLeft <= 0) {
					updatedAudioChucks.splice(updateIdx, 1)
				} else {
					updatedAudioChucks[updateIdx] = { ...action?.payload }
				}
			}
			return updatedAudioChucks
		}
		case AudioChuckActionType.RESET_AUDIO_CHUCKS:
			return init()
		case AudioChuckActionType.REMOVE_UPLOADED_CHUNKS:
			return filter([...initialState], (chuck) => chuck.state != "COMPLETED")
		default:
			return initialState
	}
}
